import { Component } from '@angular/core';
import { ElementRef, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { NgForm, ControlContainer, NgModelGroup } from '@angular/forms';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import flatpickr from 'flatpickr';

/**
 * Component providing implementation of a system metadata edit field.
 */
@Component({
	selector: 'edit-field',
	templateUrl: './edit-field.component.html',
	styleUrl: './edit-field.component.css',
	viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }]
})
export class EditFieldComponent implements OnInit {
	@Input() parentForm!: NgForm;
	@Input() field: any;
	@Input() values: any[] = [];
	@Output() triggerBrowseEdit = new EventEmitter<{ fieldName: string, index: number }>();
	@Output() triggerGeotag = new EventEmitter<{ fieldName: string, index: number }>();

	LOCALIZATION: any;

	dateFormat: string = 'MM/dd/yyyy';
	datePickerOptions: any = {};
	mapEnabled: boolean = false;

	constructor(
		private configService: ConfigService,
		private userService: UserService,
		private elementRef: ElementRef
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	ngOnInit() {
		this.mapEnabled = this.configService.getConfig()?.esri.enabled;
		this.dateFormat = this.userService.getDateFormat();

		if (this.field.type === 'DATE') {
			// Create field-specific datePickerOptions with min/max date
			var opts = this.userService.getDatePickerOptions(this.field.min, this.field.max, undefined, this.field.name);
			this.datePickerOptions = opts;
		} else if (this.field.type === 'LIST') {
			// Apply any dependent value filters
			for (let i = 0; i < this.values.length; i++) {
				this.updateFn(this.field, this.values[i]);
			}
		}
	}

	trackByIndex(index: number, formItem: any): number {
		return index;
	}

	updateFn(formItem: any, formValue: any) {
		// This function is implemented in fields.service.ts
		formItem.updateFn(formItem, false, formValue);
	}

	/**
	 * Opens a date picker for the field.
	 */
	openDatePicker(index: number): void {
		let target = this.elementRef.nativeElement.querySelector(`#daterange_${this.field.name}${index}`);
		if (!target._flatpickr) {
			const datepicker = flatpickr(target, {
				...this.datePickerOptions
			});

			this.field.datepicker = datepicker;
		}
		if (target._flatpickr.isOpen) {
			target._flatpickr.close();
		} else {
			target._flatpickr.open();
		}
	}

	addValue(): void {
		// Do we need this LIST logic?
		//		if (this.field.type === "LIST" && this.field.options && this.field.options.length > 0) {
		//			this.values.push("" + this.field.filteredOptions[0].value);
		//		} else {
		//			this.values.push("");
		//		}
		this.values.push("");
	}

	removeValue(index: number): void {
		this.values.splice(index, 1);
	}

	// Bound in the template
	onGeotag(index: number): void {
		this.triggerGeotag.emit({ fieldName: this.field.name, index: index });
	}

	// Bound in the template
	onBrowseEdit(index: number): void {
		this.triggerBrowseEdit.emit({ fieldName: this.field.name, index: index });
	}
}
